var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$store.state.View.takt_time_filter.active || (_vm.index > _vm.$store.state.View.takt_time_filter.start && _vm.index < _vm.$store.state.View.takt_time_filter.end))?_c('div',{staticClass:"high-lighter",style:(`
    left: calc((${_vm.$store.state.View.takt_time_filter.active ? _vm.index - _vm.$store.state.View.takt_time_filter.start - 1 : _vm.index} * (var(--workpackage_width) + 8px) + ${_vm.header_width}) * var(--taktplan_zoom);
    ${_vm.z_index ? `z-index: ${_vm.z_index};` : ''}
    ${_vm.border_style ? `border-right-style: ${_vm.border_style};` : ''}
    `)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }